module.exports = __webpack_public_path__ + "img/icon_trade_qixia.03732098.png";